// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__lDWRK","button":"styles_button__1vugB"};